module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "iosnode"
  }, [_c('h1', {
    staticClass: "titlepage-title",
    attrs: {
      "id": "A-157755_29"
    }
  }, [_vm._v("How to Read Tarot")]), _vm._v(" "), _c('h2', {
    staticClass: "titlepage-subtitle",
    attrs: {
      "id": "A-157755_33"
    }
  }, [_vm._v("A Practical Guide")]), _vm._v(" "), _c('p', {
    staticClass: "titlepage-imprintlogo",
    attrs: {
      "id": "A-157755_37"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Adams Media logo",
      "src": "images/logo-adams.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "titlepage-imprintaddress",
    attrs: {
      "id": "A-157755_41"
    }
  }, [_vm._v("Avon, Massachusetts")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb81d3e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/N157755.vue
// module id = 63
// module chunks = 0